import React from 'react';

export default function SkeletonList({ count = 6, compact = false }) {
	return (
		<div>
			{Array.from({ length: count }).map((_, idx) => (
				<div
					key={idx}
					className={`flex items-center gap-3 p-3 my-2 rounded-[100px] bg-gray-200 bg-opacity-60 animate-pulse w-full ${compact ? 'py-1' : 'py-2'}`}
				>
					<div className="h-12 w-12 rounded-full bg-gray-300" />
					<div className="flex-1 space-y-2">
						<div className="h-4 w-32 bg-gray-300 rounded" />
						<div className="h-3 w-24 bg-gray-300 rounded" />
					</div>
					<div className="flex items-center gap-2">
						<div className="h-8 w-8 rounded-full bg-gray-300" />
						<div className="h-8 w-8 rounded-full bg-gray-300" />
					</div>
				</div>
			))}
		</div>
	);
}
